/*------------------------------------------------
// File Name:PDM_BodyCheck_TaoCanType.js
// File Description:PDM_BodyCheck_TaoCanType API方法js接口
// Author:zxl
// Create Time:2023/04/11 11:48:22
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _bodycheckTaocantype: "/PDM_BodyCheck_TaoCanType"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_BodyCheck_TaoCanTypeEntity(parameter) {
    return axios({
        url: api._bodycheckTaocantype + "/CreatePDM_BodyCheck_TaoCanTypeEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_BodyCheck_TaoCanTypeList(parameter) {
    return axios({
        url: api._bodycheckTaocantype + "/GetPDM_BodyCheck_TaoCanTypeList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_BodyCheck_TaoCanTypeListByPage(parameter) {
    return axios({
        url: api._bodycheckTaocantype + "/GetPDM_BodyCheck_TaoCanTypeListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_BodyCheck_TaoCanTypeEntity(parameter) {
    return axios({
        url: api._bodycheckTaocantype + "/GetPDM_BodyCheck_TaoCanTypeEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_BodyCheck_TaoCanTypeEntity(parameter) {
    return axios({
        url: api._bodycheckTaocantype+ "/UpdatePDM_BodyCheck_TaoCanTypeEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_BodyCheck_TaoCanTypeEntity(parameter) {
    return axios({
        url: api._bodycheckTaocantype + "/DeletePDM_BodyCheck_TaoCanTypeEntity",
        method: 'post',
        data: parameter
    })
}
